import { render, staticRenderFns } from "./ConsignmentSummaryReportRcvTable.vue?vue&type=template&id=6181c82e&scoped=true"
import script from "./ConsignmentSummaryReportRcvTable.vue?vue&type=script&lang=js"
export * from "./ConsignmentSummaryReportRcvTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181c82e",
  null
  
)

export default component.exports